import type {TestIdValue} from '../types';

export const transformHiddenFunctionalityArrayToObject = (
    hiddenFunctionalityArray: TestIdValue[],
): Record<TestIdValue, true> =>
    Object.fromEntries(hiddenFunctionalityArray.map(testId => [testId, true]));
